export const onboardingConfig = {
  step1: {
    question: "What is your target audience for email campaigns?",
    options: [
      {
        label: "B2B : Businesses or professionals",
        subLabel: "Targeting G Suite or MS365 inboxes for outreach.",
        value: "b2b",
      },
      {
        label: "B2C : Consumers",
        subLabel: "Targeting Gmail or Yahoo inboxes for marketing campaigns.",
        value: "b2c",
      },
      {
        label: "Both : B2B & B2C",
        subLabel: "Targeting a mix of business and consumer inboxes.",
        value: "both",
      },
    ],
  },
  step2: {
    question:
      "What is the size of your organization in terms of employee count?",
    options: [
      { label: "1-10 employees", value: "1_10" },
      { label: "11-50 employees", value: "11_50" },
      { label: "51-200 employees", value: "51_200" },
      { label: "201-500 employees", value: "201_500" },
      { label: "500+ employees", value: "500_plus" },
    ],
  },
  step3: {
    question: "In which industry does your organization primarily operate?",
    options: [
      { label: "E-commerce", value: "ecommerce" },
      { label: "Technology", value: "technology" },
      { label: "Marketing", value: "marketing" },
      { label: "Finance", value: "finance" },
      {
        label: "Healthcare",
        value: "healthcare",
      },
      { label: "Education", value: "education" },
      { label: "Real Estate", value: "real_estate" },
      { label: "Retail", value: "retail" },
      { label: "Manufacturing", value: "manufacturing" },
      { label: "Hospitality", value: "hospitality" },
      { label: "Legal Services", value: "legal_services" },
    ],
  },
  step4: {
    question:
      "Has your organization previously utilized an email warmup service?",
    options: [
      {
        label: "Yes, with a human-powered email warmups service",
        value: "human_based",
      },
      {
        label: "Yes, with an automated or bot-based service",
        value: "automated",
      },
      {
        label:
          "No, this is our first experience with human powered email warmups",
        value: "first_time",
      },
    ],
  },
  step5: {
    question: "How many mailboxes/domains do you use to send emails?",
    options: [
      { label: "Under 10", value: "under_10" },
      { label: "10-20", value: "10_20" },
      { label: "20-50", value: "20_50" },
      { label: "50-100", value: "50_100" },
      { label: "100-500", value: "100_500" },
      { label: "More than 500", value: "more_than_500" },
    ],
  },
  step6: {
    question: "What's your monthly email volume?",
    options: [
      { label: "Under 10,000 per month", value: "under_10000" },
      { label: "10,000-20,000 per month", value: "10000_20000" },
      { label: "20,000-50,000 per month", value: "20000_50000" },
      { label: "50,000-100,000 per month", value: "50000_100000" },
      { label: "100,000-1,000,000 per month", value: "100000_1000000" },
      { label: "1,000,000 - 5,000,000 per month", value: "1000000_5000000" },
      { label: "Higher than 5,000,000 per month", value: "above_5000000" },
    ],
  },
  step7: {
    question: "How did you hear about InboxDoctor?",
    options: [
      { label: "Search engine (e.g., Google)", value: "search_engine" },
      {
        label: "Social media (e.g., Twitter/X, LinkedIn)",
        value: "social_media",
      },
      { label: "Referral from a colleague or friend", value: "referral" },
      { label: "Online advertisement", value: "online_ad" },
      { label: "Industry event or conference", value: "industry_event" },
      { label: "Blog or article", value: "blog_article" },
    ],
  },
};
